import {
  cfacebook,
  cinstagram,
  cx,
  cwhatsapp,
  cyoutube,
  csnapchat,
  contactphone,
  contactmessage,
  contactpin,
  erroricon,
  tiktok,
} from "assets/icons/index";
import Footer from "components/Footer";
import Header from "components/Header";
import MainTitle from "components/MainTitle";
import QuickDonate from "components/QuickDonate/QuickDonate";
import QuickDonatePopUp from "components/QuickDonate/QuickDonatePopUp";
import { RootState } from "redux/rootReducer";
import { useSelector } from "react-redux";
import { useContactUsFormik } from "Forms/contactUsFromik";
import { Spin } from "antd";
import { useTranslation } from "react-i18next";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { useState } from "react";

const ContactUs = () => {
  const [country, setCountry] = useState("uae");
  const { t, i18n } = useTranslation();
  const formik = useContactUsFormik(country);

  const { quickDonateStatus } = useSelector(
    (state: RootState) => state.setQuickDonatePopStateReducer
  );

  const { contactUsLoading } = useSelector(
    (state: RootState) => state.contactUsReducer
  );

  return (
    <>
      <Header />

      <main className="relative">
        {/* quick donate */}
        <QuickDonate />

        {/* quick donate popup  */}
        {quickDonateStatus && <QuickDonatePopUp />}

        <MainTitle title={t("Contact Us")} />

        <section
          data-aos="fade-up"
          data-aos-duration="900"
          className="my-[100px] w-full px-[20px] lg:px-0"
        >
          <div className="mainContainer">
            <div className="flex flex-col lg:flex-row items-center gap-[25px]">
              {/* socail and contact numbers  **********************/}
              <div className="w-full lg:w-[485px] shadow-shadow_main rounded-[15px] p-[20px] flex flex-col gap-[50px]">
                {/* social  */}
                <div className="w-full flex items-center justify-center">
                  <div className="flex items-center gap-6 lg:gap-6">
                    {/* facebook */}
                    <a
                      href="https://m.facebook.com/etihadcharity"
                      target="_blank"
                    >
                      <img
                        className="hover:scale-150 duration-300"
                        src={cfacebook}
                        alt=""
                      />
                    </a>

                    {/* instagram */}
                    <a
                      href="https://instagram.com/etihadcharity?igshid=YmMyMTA2M2Y="
                      target="_blank"
                    >
                      <img
                        className="hover:scale-150 duration-300"
                        src={cinstagram}
                        alt=""
                      />
                    </a>

                    {/* x */}
                    <a
                      href="https://twitter.com/etihadcharity?s=20&t=qrWYlqbLqUzvt6gx1W0P8g"
                      target="_blank"
                    >
                      {" "}
                      <img
                        className="hover:scale-150 duration-300"
                        src={cx}
                        alt=""
                      />
                    </a>

                    {/* whatsapp */}
                    <a
                      href="https://api.whatsapp.com/send?phone=97180062&text=Hi"
                      target="_blank"
                    >
                      {" "}
                      <img
                        className="hover:scale-150 duration-300"
                        src={cwhatsapp}
                        alt=""
                      />
                    </a>

                    {/* youtube */}
                    <a
                      href="https://www.youtube.com/channel/UCpXCNb-HmlKfNHfSiE4CIeA"
                      target="_blank"
                    >
                      <img
                        className="hover:scale-150 duration-300"
                        src={cyoutube}
                        alt=""
                      />
                    </a>

                    {/* snapchat */}
                    <a
                      href="https://www.snapchat.com/add/miecajman"
                      target="_blank"
                    >
                      {" "}
                      <img
                        className="hover:scale-150 duration-300"
                        src={csnapchat}
                        alt=""
                      />
                    </a>

                    {/* tiktok */}
                    <a
                      href="https://www.tiktok.com/@etihad_charity?_t=ZS-8uyUVUF8EHC&_r=1"
                      target="_blank"
                    >
                      {" "}
                      <img
                        className="w-[28px] hover:scale-150 duration-300"
                        src={tiktok}
                        alt=""
                      />
                    </a>
                  </div>
                </div>

                {/* contact info ***********************************/}
                <div className="flex flex-col gap-[40px]">
                  {/* phone */}
                  <div className="flex flex-col lg:flex-row items-center gap-[20px]">
                    {/* imgage */}
                    <div className="w-[65px] h-[65px] bg-[#E9EBEC] flex items-center justify-center rounded-full">
                      <img src={contactphone} alt="" />
                    </div>

                    <div className="flex flex-col items-center lg:items-start gap-[4px]">
                      <p
                        className={`font-${
                          i18n.language === "en" ? "Poppins" : "Almarai"
                        } font-[400] text-[16px] text-[#263A4B]`}
                      >
                        {t("Toll Free")}
                      </p>

                      <p
                        className={`font-${
                          i18n.language === "en" ? "Poppins" : "Almarai"
                        } font-[600] text-[15px]`}
                      >
                        80062
                      </p>
                      <p></p>
                    </div>
                  </div>

                  {/* email */}
                  <div className="flex items-center flex-col lg:flex-row gap-[20px]">
                    {/* imgage */}
                    <div className="w-[65px] h-[65px] bg-[#E9EBEC] flex items-center justify-center rounded-full">
                      <img src={contactmessage} alt="" />
                    </div>

                    <div className="flex flex-col items-center lg:items-start gap-[4px]">
                      <p
                        className={`font-${
                          i18n.language === "en" ? "Poppins" : "Almarai"
                        } font-[400] text-[16px] text-[#263A4B]`}
                      >
                        {t("Email")}
                      </p>

                      <p
                        className={`font-${
                          i18n.language === "en" ? "Poppins" : "Almarai"
                        } font-[600] text-[15px] hover:text-first_color duration-300`}
                      >
                        <a href="mailto:info@etihadcharity.ae">
                          info@etihadcharity.ae
                        </a>
                      </p>
                      <p></p>
                    </div>
                  </div>

                  {/* address  */}
                  <div className="flex items-center flex-col lg:flex-row gap-[20px]">
                    {/* imgage */}
                    <div className="w-[65px] h-[65px] bg-[#E9EBEC] flex items-center justify-center rounded-full">
                      <img src={contactpin} alt="" />
                    </div>

                    <div className="flex flex-col items-center lg:items-start gap-[4px]">
                      <p
                        className={`font-${
                          i18n.language === "en" ? "Poppins" : "Almarai"
                        } font-[400] text-[16px] text-[#263A4B]`}
                      >
                        {t("Company Address")}
                      </p>

                      <p
                        className={`font-${
                          i18n.language === "en"
                            ? "Poppins lg:text-left"
                            : "Almarai lg:text-right"
                        } font-[600] text-[15px] max-w-[330px] text-center `}
                      >
                        {t(
                          "Sheikh Maktoum Bin Rashid Street, Al Jurf 2, Ajman, United Arab Emirates"
                        )}
                      </p>
                      <p></p>
                    </div>
                  </div>
                </div>
              </div>

              {/* contact form  **********************************/}
              <div className="w-full shadow-shadow_main rounded-[15px] p-[20px] flex flex-col gap-[20px]">
                <p
                  className={`font-${
                    i18n.language === "en" ? "Poppins" : "Almarai"
                  } font-[600] text-[18px] text-second_color`}
                >
                  {t("Leave a message below, And we will contact soon.")}
                </p>

                <Spin spinning={contactUsLoading}>
                  <form
                    onSubmit={formik.handleSubmit}
                    className="flex flex-col gap-[20px]"
                  >
                    {/* firtst and last name  ******************/}
                    <div className="flex flex-col lg:flex-row items-center gap-[20px]">
                      {/* first name  **********/}
                      <div className="w-full">
                        <input
                          type="text"
                          name="firstName"
                          onChange={formik.handleChange}
                          placeholder={t("First Name")}
                          className={`w-full h-[48px] rounded-[10px] font-${
                            i18n.language === "en"
                              ? "Poppins pl-[24px]"
                              : "Almarai pr-[24px]"
                          } font-[400] text-[16px] text-[#707070] border border-[#B6B6B6]`}
                        />

                        {formik.errors.firstName ? (
                          <p
                            className={`mt-[5px] font-${
                              i18n.language === "en" ? "Poppins" : "Almarai"
                            } font-[600] text-[12px] text-red-600 flex items-center gap-2`}
                          >
                            <img
                              className="max-w-[18px]"
                              src={erroricon}
                              alt=""
                            />
                            {formik.errors.firstName}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>

                      {/* last name  **********/}
                      <div className="w-full">
                        <input
                          type="text"
                          name="lastName"
                          onChange={formik.handleChange}
                          placeholder={t("Last Name")}
                          className={`w-full h-[48px] rounded-[10px] font-${
                            i18n.language === "en"
                              ? "Poppins pl-[24px]"
                              : "Almarai pr-[24px]"
                          } font-[400] text-[16px] text-[#707070] border border-[#B6B6B6] `}
                        />
                        {formik.errors.lastName ? (
                          <p
                            className={`mt-[5px] font-${
                              i18n.language === "en" ? "Poppins" : "Almarai"
                            } font-[600] text-[12px] text-red-600 flex items-center gap-2`}
                          >
                            <img
                              className="max-w-[18px]"
                              src={erroricon}
                              alt=""
                            />
                            {formik.errors.lastName}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    {/* email and phone ******************/}
                    <div className="flex flex-col lg:flex-row items-center gap-[20px]">
                      {/* email   ************/}
                      <div className="w-full">
                        <input
                          type="email"
                          name="email"
                          onChange={formik.handleChange}
                          placeholder={t("Email")}
                          className={`w-full h-[48px] rounded-[10px] font-${
                            i18n.language === "en"
                              ? "Poppins pl-[24px]"
                              : "Almarai pr-[24px]"
                          } font-[400] text-[16px] text-[#707070] border border-[#B6B6B6] `}
                        />

                        {formik.errors.email ? (
                          <p
                            className={`mt-[5px] font-${
                              i18n.language === "en" ? "Poppins" : "Almarai"
                            } font-[600] text-[12px] text-red-600 flex items-center gap-2`}
                          >
                            <img
                              className="max-w-[18px]"
                              src={erroricon}
                              alt=""
                            />
                            {formik.errors.email}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>

                      {/* phone  **********/}
                      <div className="w-full">
                        <PhoneInput
                          inputStyle={{
                            width: "100%",
                            height: "48px",
                            borderRadius: "10px",
                          }}
                          country={"ae"}
                          countryCodeEditable={false}
                          enableSearch={true}
                          onChange={(phone, x, y, valueseparated) => {
                            // the country code
                            const countryCode = valueseparated
                              .split(" ")
                              .shift();
                            formik.setFieldValue("countryCode", countryCode);

                            if (countryCode === "+20") {
                              setCountry("eg");
                            } else if (countryCode === "+971") {
                              setCountry("uae");
                            }
                            const countryCodeLength = countryCode
                              ?.split("")
                              .filter((item: any, idx: number) => idx !== 0)
                              .join("").length;

                            // phone number
                            const phoneNumber = phone.slice(
                              countryCodeLength,
                              phone.length
                            );
                            formik.setFieldValue("phone", phoneNumber);
                          }}
                        />
                        {formik.errors.phone ? (
                          <p
                            className={`mt-[5px] font-${
                              i18n.language === "en" ? "Poppins" : "Almarai"
                            } font-[600] text-[12px] text-red-600 flex items-center gap-2`}
                          >
                            <img
                              className="max-w-[18px]"
                              src={erroricon}
                              alt=""
                            />
                            {formik.errors.phone}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    {/* message area  ******************/}
                    <div>
                      <textarea
                        name="message"
                        onChange={formik.handleChange}
                        placeholder={t("Message")}
                        className={`w-full h-[48px] rounded-[10px] font-${
                          i18n.language === "en"
                            ? "Poppins pl-[24px]"
                            : "Almarai pr-[24px]"
                        } font-[400] text-[16px] text-[#707070] border border-[#B6B6B6]  pt-[24px] min-h-[111px]`}
                      ></textarea>{" "}
                      {formik.errors.message ? (
                        <p
                          className={`mt-[5px] font-${
                            i18n.language === "en" ? "Poppins" : "Almarai"
                          } font-[600] text-[12px] text-red-600 flex items-center gap-2`}
                        >
                          <img
                            className="max-w-[18px]"
                            src={erroricon}
                            alt=""
                          />
                          {formik.errors.message}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>

                    {/* send message button  ******************/}
                    <div className="flex justify-end">
                      <button
                        type="submit"
                        className={`mt-[20px] w-[245px] h-[48px] bg-first_color rounded-[10px] text-white font-${
                          i18n.language === "en" ? "Poppins" : "Almarai"
                        } font-[600] text-[16px]`}
                      >
                        {t("Send Message")}
                      </button>
                    </div>
                  </form>
                </Spin>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default ContactUs;
